import { formatDistanceToNowStrict } from 'date-fns';

export const formatLastUpdated = (lastUpdatedDate: Date | undefined): string | undefined => {
  if (lastUpdatedDate) {
    return formatDistanceToNowStrict(lastUpdatedDate, { addSuffix: true });
  }
};
